import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy'
import { routeBackOfficeSoundAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeSoundAdminCommon'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

const getBackOfficeSoundAdminItaly = [
  ...routeBackOfficeSoundAdminCommon,
  {
    route: 'PharmaciesList',
    text: 'Liste des pharmacies',
    icon: LocalPharmacyIcon,
    href: '/backoffice/common/pharmacy',
    menuHeader: true,
    position: 20,
  },
  {
    route: 'editCompany',
    text: 'Edition établissement',
    href: '/backoffice/common/company/edit-company/[companyId]',
    menuHeader: false,
  },
  {
    route: 'MyProfile',
    text: 'Mon profil',
    href: '/backoffice/common/my-profile',
    menuHeader: false,
  },
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDISOUND],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_SOUND_ITALY_ADMIN],
}))

export default getBackOfficeSoundAdminItaly
